import { useEffect, useMemo, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import TableFilter from "src/components/TableFilter";

const FilteringComponent = ({
    t,
    statuses,
    owners,
    ownersAreLoading,
    priorities,
    onChange
}) => {
    const [ tableFilters, setTableFilters ] = useState({
        status: null,
        owner: null,
        priority: null
    });
    const initRef = useRef(false);

    const statusOptions = useMemo(() => {
        return (statuses || []).map((item) => ({
            ...item,
            id: item.value
        }))
    }, [ statuses ]);

    const priorityOptions = useMemo(() => {
        return (priorities || []).map((item) => ({
            ...item,
            id: item.value
        }))
    }, [ priorities ]);

    const ownersOptions = useMemo(() => {
        return (owners || []).map((item) => ({
            ...item,
            id: item.value
        }))
    }, [ owners ]);

    const tableFilterTabs = useMemo(() => {
        return [
            {
                type: 'radio_list',
                name: 'status',
                title: 'Task Status',
                icon: <i className="ri-checkbox-circle-line" />,
                isLoading: false,
                defaultValue: tableFilters.status,
                data: statusOptions,
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.label
                }
            },
            {
                type: 'radio_list',
                name: 'priority',
                title: 'Priority',
                icon: <i className="ri-arrow-up-down-fill" />,
                isLoading: false,
                defaultValue: tableFilters.priority,
                data: priorityOptions,
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return t(item.baseLabel) 
                }
            },
            {
                type: 'radio_list',
                name: 'owner',
                title: 'Owner',
                icon: <i className="ri-user-line" />,
                isLoading: ownersAreLoading,
                defaultValue: tableFilters.owner,
                data: ownersOptions,
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.label
                }
            }
        ]
    }, [
        tableFilters,
        statusOptions,
        ownersOptions,
        ownersAreLoading,
        priorityOptions,
        t
    ]);

    const onTableFilterOkButtonClicked = (filters) => {
        if (filters) {
            const result = {}
            if ('status' in filters) {
                result.status = filters.status !== 'all' ? filters.status : undefined
            }

            if ('owner' in filters) {
                result.owner = filters.owner !== 'all' ? filters.owner : undefined
            }

            if ('priority' in filters) {
                result.priority = filters.priority !== 'all' ? filters.priority : undefined
            }

            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                status: null,
                owner: null,
                priority: null
            })
        }
    }

    useEffect(() => {
        if(!initRef.current){
            initRef.current = true;
            return;
        }

        onChange && onChange(tableFilters)
    }, [ tableFilters ]);

    return (
        <TableFilter
            className="me-2"
            defaultActiveTab='status'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

export default withNamespaces()(FilteringComponent);